// extracted by mini-css-extract-plugin
module.exports = {"container":"ScreenOrientation_container__g43QO"};